import { defaultAppConfig } from "./default-app-config";

type AppEnvironment = 'stage' | 'dev';

interface IAppConstants {
  APP_ENVIRONMENT: AppEnvironment;
}

export const AppConstants: IAppConstants = {
  APP_ENVIRONMENT: 'stage',
};


export enum FeatureAppNames {
  BATTERY_LABEL = 'battery-label',
  DEFAULT = 'default',
}


export const appsUMD = {
  [FeatureAppNames.BATTERY_LABEL]: '/assets/battery-label/battery-label-umd.js',
  [FeatureAppNames.DEFAULT]: defaultAppConfig.appsUMD,
};

export const appsCommonsJS = {
  [FeatureAppNames.BATTERY_LABEL]:
    '/assets/battery-label/battery-label-commonjs.js',
  [FeatureAppNames.DEFAULT]: defaultAppConfig.appsCommonsJS,
};


